import { render, staticRenderFns } from "./main-product.vue?vue&type=template&id=f4d02f58&"
import script from "./main-product.vue?vue&type=script&lang=js&"
export * from "./main-product.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports